import { CateringCategoryQuery } from 'components/pages/CateringPage/types/CateringCategoryQuery'
import Image from 'components/Image'
import HERO_IMAGE from 'images/party-2-small.jpg'
import React from 'react'
import replaceCategoryVariables from 'components/pages/CateringPage/replaceCategoryVariables'
import CtaLink from 'components/ui/CtaLink'

type Props = {
  category: NonNullable<CateringCategoryQuery['cateringCategory']>
  market?: {
    name: string
    state: string
  } | null
}

const HeroSection = ({ category, market }: Props) => {
  return (
    <main className="lg:relative w-full bg-gray-100">
      <div className="mx-auto max-w-7xl w-full pt-16 pb-20 text-center lg:py-48 lg:text-left">
        <div className="px-4 lg:w-1/2 sm:px-8 xl:pr-16">
          <h1 className="text-4xl tracking-tight font-extrabold text-gray-900 sm:text-5xl md:text-6xl lg:text-5xl xl:text-6xl">
            <span className="block xl:inline">
              {replaceCategoryVariables({
                text: category.title,
                market: market?.name
              })}
            </span>{' '}
          </h1>
          <div className="mt-3 max-w-md mx-auto md:mt-5 md:max-w-3xl text-xl">
            {category.subtitle}
          </div>

          <div className="mt-10 sm:flex sm:justify-center lg:justify-start">
            <CtaLink
              href={`/hire-food-truck${
                category.mainPage
                  ? ''
                  : `?event=${encodeURIComponent(category.name)}`
              }`}
              prefetch={false}
            >
              <p className="whitespace-nowrap">
                Hire a food truck {market && `in ${market.name}`}
              </p>
            </CtaLink>
          </div>
        </div>
      </div>
      <div className="relative w-full h-64 sm:h-72 md:h-96 lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2 lg:h-full">
        <Image
          className="absolute inset-0 w-full h-full object-cover object-center"
          layout="fill"
          sizes="50vw"
          src={category.image?.big || HERO_IMAGE}
          priority
        />
      </div>
    </main>
  )
}

export default HeroSection
